export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=402a7dfb9053ff27af0e9b1c863b292031c47bb02b&name=revalidateCommunity!'